import { sessionStorageInstance } from "../services/storage/Storage";
import _ from "lodash";

export class CategoryUtils {
    static readonly KEY_NAME = 'cached_categories';

    public static resetCachedInfo(){
        sessionStorageInstance.removeData(this.KEY_NAME);
    }

    public static putData(categoryName: string, place: number){
        if(!sessionStorageInstance.hasKey(this.KEY_NAME)){
            let data = {
                categories: [
                    {categoryName: categoryName, place: place}
                ]
            }
            sessionStorageInstance.setData(this.KEY_NAME, JSON.stringify(data));
        } else {
            let data = JSON.parse(sessionStorageInstance.getData(this.KEY_NAME)!!);
            data.categories.push(
                {categoryName: categoryName, place: place}
            );
            sessionStorageInstance.setData(this.KEY_NAME, JSON.stringify(data));
        }
    }

    public static getData(categoryName: string): object {
        let data = JSON.parse(sessionStorageInstance.getData(this.KEY_NAME)!!);
        let index = _.findIndex(data.categories, (value: object) => {
            //@ts-ignore
            return value.categoryName === categoryName;
        });
        return data.categories[index];
    }
}